module.exports = __webpack_public_path__ + "static/img/icon_back.532ec16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_back.png
// module id = 4
// module chunks = 1